<template>
  <section>
    <v-container fluid>



      <v-col cols="12">
        <v-row justify="space-between">
          <v-col cols="auto" class="py-0">
            <div class="font-weight-bold"> {{ $global.FilterPermissions('06-012').sub_title | capitalize }}</div>
          </v-col>
          <v-col cols="10" class="pa-1 py-2">
            <v-row align="center" justify="end">
              <GenericInput type="select" :clearable="true" :dense="true" paddingY="py-2 py-lg-0"
                paddingX="px-4 px-lg-3" backgroundColor="white" :lookups="items" selected_label="name"
                selected_prop="id" :value="filter.items" :multi="true" @input="filter.items = $event" label="items"
                :isLoading="false" :hideDetails="true" :cols="[12, 4, 6]"></GenericInput>

              <GenericInput type="select" :clearable="true" :dense="true" paddingY="py-  py-lg-0"
                paddingX="px-4 px-lg-3" backgroundColor="white" :lookups="types" selected_label="title"
                selected_prop="id" :value="filter.report_type" :multi="false" @input="filter.report_type = $event"
                label="types" :isLoading="false" :hideDetails="true" :cols="[12, 4, 3]"></GenericInput>

              <GenericInput type="select" :clearable="true" :dense="true" paddingY="py-2 py-lg-0"
                paddingX="px-4 px-lg-3" backgroundColor="white" :lookups="payment_types" selected_label="name"
                selected_prop="id" :value="filter.payment_type" :multi="false" @input="filter.payment_type = $event"
                label="payment type" :isLoading="false" :hideDetails="true" :cols="[12, 4, 3]"></GenericInput>

              <GenericInput type="date" :isPickerOpened="() => filter.to_date = null" :clearable="true"
                :maxDate="filter.to_date || today" :dense="true" paddingY="py-2 py-lg-0" paddingX="px-4 px-lg-3"
                backgroundColor="white" :value="filter.from_date" :multi="true" @input="filter.from_date = $event"
                label="from" :isLoading="false" :hideDetails="true" :cols="[12, 4, 3]">
              </GenericInput>
              <GenericInput type="date" :clearable="true" :minDate="filter.from_date" :maxDate="today" :dense="true"
                paddingY="py-2 py-lg-0" paddingX="px-4 px-lg-3" backgroundColor="white" :value="filter.to_date"
                :multi="true" @input="filter.to_date = $event" label="to" :isLoading="false" :hideDetails="true"
                :cols="[12, 4, 3]">
              </GenericInput>

              <v-col cols="12" md="4" lg="auto" class="d-flex">
                <ExportBtnNB v-if="rows.length" :exportData="rows" pdfOrientation="landscape" :header="header"
                  :footerData="[footerData[0]]" :groupHeader="[]" :openOnHover="false"
                  :attachmentFileName="$global.FilterPermissions('06-012').sub_title"
                  :printTitle="$global.FilterPermissions('06-012').sub_title" :printSubTitleRight="null"
                  classes="shadow mx-2 rounded-lg white--text accent">
                  <template v-slot:pdf_header>
                    <div class="printFilterHeader">
                      <div v-if="filter.from_date">{{ $t("from date") }} : {{ filter.from_date }}</div>
                      <div v-if="filter.to_date">{{ $t("to date") }} : {{ filter.to_date }}</div>
                    </div>
                  </template>
                  <template v-slot:td="{ row, header }">
                    <span class="d-flex justify-center" v-if="header.key !== 'invoice_code' && header.key !== 'r_m_id'">
                      <span v-if="row.sumtion == 2">({{ row[header.key] || 0 | float }})</span>
                      <span v-else>{{ row[header.key] || 0 | float }}</span>
                    </span>
                    <span class="d-flex justify-center" v-else>
                      <span>{{ row[header.key] || "-" }}</span>
                    </span>
                  </template>
                </ExportBtnNB>

                <v-btn :loading="isLoading" small @click="getReports()" :height="35" :width="100"
                  class="d-block mi-start-auto rounded-lg white--text" color="blue4" outlined>
                  {{ $t("search") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>







      <v-card class="mt-5 shadow overflow-hidden">
        <v-row align="center" justify="space-between">
          <v-col cols="auto" class="mb-2">
            <v-tabs v-model="tab" active-class="secondary white--text" color="secondary">
              <v-tab>{{ $t('reports') }}</v-tab>
              <v-tab :disabled="rows.length == 0">{{ $t('statistics') }}</v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="auto" class="mx-5" v-if="tab == 1">
            <v-btn small @click="chartType = 1" fab :color="chartType == 1 ? 'primary' : 'gray12'" class="mx-1"
              depressed>
              <v-icon>mdi-chart-bell-curve</v-icon>
            </v-btn>
            <v-btn small @click="chartType = 2" fab :color="chartType == 2 ? 'primary' : 'gray12'" class="mx-1"
              depressed>
              <v-icon>mdi-chart-bar</v-icon>
            </v-btn>
            <v-btn small @click="chartType = 3" fab :color="chartType == 3 ? 'primary' : 'gray12'" class="mx-1"
              depressed>
              <v-icon>mdi-chart-donut</v-icon>
            </v-btn>
            <v-btn small @click="chartType = 4" fab :color="chartType == 4 ? 'primary' : 'gray12'" class="mx-1"
              depressed>
              <v-icon>mdi-chart-timeline</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-col cols="12" sm="12">
              <DynamicTable :isLoading="isLoading" :searchMethod="searchMethod" :controlRoute="controlRoute"
                :searchByDateRange="false" :option="options" :viewSearch="false" :editValueMethod="edit"
                printURL="full_report" :tableHeight="$store.state.Settings.windowSize.y - 270"
                :printValueMethod="printValueMethod" btnIcon="mdi-share" :data="rows" :header="header"
                :footerData="footerData" noDataText="please select to view report">
              </DynamicTable>
            </v-col>
          </v-tab-item>
          <v-tab-item v-if="rows.length > 0">
            <v-col cols="12" sm="12" class="pa-0">
              <v-card flat relative :height="$store.state.Settings.windowSize.y - 250">
                <FullChart v-if="chartType == 2" :key="analysisKey" :quantities="quantities" :summary="summary"
                  :summary_categories="summary_categories" />

                <FullChartCurve v-if="chartType == 1" :key="analysisKey" :quantities="quantities" :summary="summary"
                  :summary_categories="summary_categories" />

                <FullChartDonut v-if="chartType == 3" :key="analysisKey" :quantities="quantities" :summary="summary"
                  :summary_categories="summary_categories" />

                <FullChartBar v-if="chartType == 4" :key="analysisKey" :quantities="quantities" :summary="summary"
                  :summary_categories="summary_categories" />
              </v-card>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <!-- <v-col cols="12" sm="12" v-if="pagination">
          <Pagination :limit="rowsNumber" :backValueMethod="changePage" :pagination="pagination" :isLoading="isLoading">
          </Pagination>
        </v-col> -->



    </v-container>
  </section>
</template>



<script>
import DynamicTable from "@/components/DynamicTable";
import ExportBtnNB from "@/components/ui/ExportBtnNB.vue";
// import Pagination from "@/components/Pagination";
import GenericInput from "@/components/GenericInput.vue";
import FullChart from "./FullChart.vue";
import FullChartBar from "./FullChartBar.vue";
import FullChartCurve from "./FullChartCurve.vue";
import FullChartDonut from "./FullChartDonut.vue";
export default {
  name: "FullReportsEntity",

  data: () => ({
    isLoading: true,
    controlRoute: null,
    optionDialog: false,
    printLoading: false,
    selectedRow: null,
    options: null,
    rows: [],
    header: [],
    pagination: null,
    page: 1,
    rowsNumber: 15,
    searchText: '',
    from: null,
    to: null,
    today: null,
    date: null,
    branches: [],
    categories: [],
    customers: [],
    locations: [],
    payment_types: [],
    items: [],
    status: [],
    times: [],
    types: [],
    summary: [],
    quantities: [],
    tab: 0,
    chartType: 1,
    analysisKey: 1,
    summary_categories: [],
    payment_methods: [],
    filter: {
      items: [],
      report_type: 0,
      payment_type: 0,
      from_date: "",
      to_date: "",
    },
    footerData: [{
      invoice_code: null,
      branch_title: null,
      customer_name: null,
      service_title: null,
      qty: 0,
      id: null,
    }],
  }),
  components: {
    DynamicTable,
    ExportBtnNB,
    FullChart,
    FullChartCurve,
    GenericInput,
    FullChartDonut,
    FullChartBar
  },
  watch: {
    rows() {
      this.footerData[0].invoice_code = this.$i18n.t('total');
      this.footerData[0].total_quantity = this.totalQTY;
      this.footerData[0].total_vat = this.totalVat;
      this.footerData[0].total_without_vat = this.totalPriceWithoutVat;
      this.footerData[0].total_with_vat = this.totalGrandPrice;
    },
    '$store.state.Settings.key_clicked'() {
      switch (this.$store.state.Settings.key_clicked) {
        case 'F5':
          this.getReports();
          break;
        default:
          break;
      }
    },
  },
  computed: {
    totalGrandPrice() {
      return this.rows.reduce((oldValue, newValue) => {
        switch (newValue.sumtion) {
          case 1:
            return Number(+oldValue) + Number(+newValue.total_with_vat);
          case 2:
            return Number(+oldValue) - Number(+newValue.total_with_vat);
        }
      }, 0);
    },
    totalQTY() {
      return this.rows.reduce((oldValue, newValue) => {
        return Number(+oldValue) + Number(+newValue.total_quantity);
      }, 0);
    },
    totalVat() {
      return this.rows.reduce((oldValue, newValue) => {
        return Number(+oldValue) + Number(+newValue.total_vat);
      }, 0);
    },
    totalPriceWithoutVat() {
      return this.rows.reduce((oldValue, newValue) => {
        return Number(+oldValue) + Number(+newValue.total_without_vat);
      }, 0);
    },
  },
  mounted() {
    this.pageMainData();
    this.today = this.$global.GetCurrentDate();
    this.filter.to_date = this.$global.GetCurrentDate();
    this.filter.from_date = this.$global.GetFirstDayOfMonth();
    this.payment_types = [
      {
        id: 0,
        name: this.$i18n.t('all')
      },
      {
        id: 1,
        name: this.$i18n.t('cash')
      },
      {
        id: 2,
        name: this.$i18n.t('network')
      },
    ]
    this.getData();
  },
  methods: {
    pageMainData() {
      this.header = [
        { text: "invoice number", key: "invoice_code", type: 'text', classes: "" },
        { text: "notice invoice", key: "r_m_id", type: 'text', classes: "" },
        { text: "invoice date", key: "invoice_date", type: 'text', classes: "", width: 120 },
        { text: "type", key: "type_title", type: 'text', classes: "" },
        { text: "branch", key: "branch_name", type: 'text', classes: "" },
        { text: "customer", key: "customer_name", type: 'text', classes: "" },
        { text: "item", key: "items_name", type: 'text', classes: "", width: 120 },
        { text: "quantity", key: "total_quantity", type: 'text', classes: "" },
        { text: "price without vat", key: "total_without_vat", type: 'float', classes: "" },
        { text: "vat", key: "total_vat", type: 'float', classes: "" },
        { text: "total with vat", key: "total_with_vat", type: 'float', classes: "" },
        // { text: "print", key: "id", type: 'actions', classes: "" },
      ];
      this.options = {
        print: true,
        delete: false,
        edit: false,
        restore: false,
        view: false,
        switch: false,
        selectRow: false,
        sortBy: "id",
        tableHeader: false,
        searchInput: false,
        printButton: false,
        handleClickRow: false,
      };
    },
    optionBackMethod(status) {
      console.log(status);
      this.optionDialog = false;
      this.selectedRow = null;
    },
    getData() {
      this.isLoading = true;
      this.$api.GET_METHOD(`full_report`).then((response) => {
        this.isLoading = false;
        if (response.check) {
          this.items = response.data.items;
          this.categories = response.data.categorys;
          this.locations = response.data.locations;
          this.branches = response.data.branchs;
          this.types = response.data.types;

          this.payment_methods = response.data?.payment_methods || [];
          this.payment_methods.unshift({ id: 0, name: this.$i18n.t("all") });

          if (this.payment_methods.length > 1) {
            this.payment_types = this.payment_methods;
          }
        }
      })

    },
    getReports() {
      this.isLoading = true;
      this.summary_categories = [];
      this.summary = [];
      this.quantities = [];
      this.tab = 0;
      this.rows = [];
      const body = {
        from: this.filter.from_date,
        to: this.filter.to_date,
        items: this.filter.items,
        report_type: this.filter.report_type,
        payment_type: this.filter.payment_type,
        type: 'json'
      }
      this.$api
        .POST_METHOD(`full_report`, body, false)
        .then((response) => {
          this.isLoading = false;
          if (response.check) {

            response.data.data.forEach(row => {
              row.type_title = this.types[Number(row.type)].title;
            })
            this.reportsRow = response.data.data;
            Object.keys(response.data.chart).forEach(service => {
              this.summary_categories.push(service);
              this.summary.push(+response.data.chart[service]['total_with_vat'].toFixed(2));
              this.quantities.push(+response.data.chart[service]['quantity']);
            });
            this.rows = response.data.data;
            this.analysisKey = this.analysisKey + 1;
            this.rows = response.data.data;
            // this.pageData.account_tree = response.data.account_tree;
          }
        });
    },
    edit(edit) {
      console.log(edit);
      this.$router.push(`${this.controlRoute}/` + edit.id)
    },


    printValueMethod() {
      this.printLoading = true;
      const body = {
        from: this.filter.from_date,
        to: this.filter.to_date,
        items: this.filter.items,
        report_type: this.filter.report_type,
        payment_type: this.filter.payment_type,
        type: 'pdf'
      }
      this.$api
        .DOWNLOAD_METHOD_BODY(`full_report`, body, `full_report.pdf`)
        .then(() => { this.printLoading = false; });


      // const src = `${this.$api.serverUrl}full_report/${row.id}?type=print&clientID=${this.$store.state.clientID}`;
      // this.$api.PrintInvoiceURL(src, row.id)
      // window.open(this.$store.state.endpointURL + `api/v1/${this.$store.state.Settings.language}/show_print_receipt_by_invoice/` + row.id);
    },
    searchMethod(text, date, from, to) {
      this.searchText = text;
      this.from = from;
      this.to = to;
      this.date = date;
      this.getReports()
    },
    changePage(page, limit) {
      this.page = page;
      this.rowsNumber = limit;
      this.getData();
    },
  },
};
</script>
